import * as React from 'react';
import MuiAlert from '@mui/material/Alert';
import { selectConfirmationDialogs, selectToasters } from '../stores/toasters-slice-handler';
import { useSelector } from 'react-redux';
import ConfirmationDialog from './confirmation-dialog';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/**
 * Creates a toaster.
 * @param {string} type The same types as in WebChat: "notice" | "warning" | "error"
 * @param {string} message
 * @param {number} duration Default duration is 5 seconds.
 * @return {JSX.Element}
 * @constructor
 */
function Toasters() {
    const toasters = useSelector(selectToasters);
    const confirmationDialogs = useSelector(selectConfirmationDialogs);

    /**
     * Render a toaster element.
     * @param toasterId
     * @param {ToasterOptions} toasterOptions
     * @return {JSX.Element}
     */
    const renderToaster = (toasterId, toasterOptions) => {
        let severity;

        switch (toasterOptions.type) {
            case 'notice':
            default:
                severity = 'info';
                break;

            case 'warning':
                severity = 'warning';
                break;

            case 'error':
                severity = 'error';
                break;
        }

        return (
            <div className="wcf-ui-toaster" key={toasterId}>
                <div className={'flex-space'}></div>
                <Alert
                    icon={false}
                    severity={severity}
                    action={
                        <>
                            <div className={'toaster-close-button'}>
                                <span
                                    className={'stw-cancel-close'}
                                    onClick={() => {
                                        toasterOptions.onClose();
                                    }}
                                ></span>
                            </div>
                        </>
                    }
                >
                    {toasterOptions.message}
                </Alert>
            </div>
        );
    };

    /**
     * @param {ConfirmationDialogOptions} confirmationDialogOptions
     */
    const renderConfirmationDialog = (confirmationDialogOptions) => {
        return (
            <ConfirmationDialog key={confirmationDialogOptions.id} {...confirmationDialogOptions}></ConfirmationDialog>
        );
    };

    return (
        <div className={'wcf-ui-toaster-manager'}>
            {Object.keys(toasters).map((toasterId) => renderToaster(toasterId, toasters[toasterId]))}
            {confirmationDialogs.map((confirmationDialogOptions) =>
                renderConfirmationDialog(confirmationDialogOptions),
            )}
        </div>
    );
}

export default Toasters;
